import React from "react";
import { withStyles } from "@mui/styles";

const styles = {
  tabsContainer: {
    display: "flex",
    borderBottom: "1px solid #c2c7dd",
  },
  tab: {
    flex: 1,
    fontWeight: "300",
    whiteSpace: "nowrap",
    textAlign: "center",
    padding: "10px 40px",
    fontSize: "16px",
    cursor: "pointer",
    position: "relative",
    color: "#767b8e",
    "&:hover": {
      color: "#3c3636",
    },
  },
  activeTab: {
    fontWeight: "600",
    color: "#3c3636",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-1px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "100%",
      height: "1px",
      background: "black",
    },
    "&::before": {
      content: '""',
      zIndex: 10,
      background: "#ecebf5",
      position: "absolute",
      bottom: "-5px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "8px",
      height: "8px",
      borderBottom: "1px solid black",
      borderLeft: "1px solid black",
      transform: "translateX(-50%) rotate(-45deg)",
    },
  },
};

const Tabs = ({ classes, tabs, labels, activeTab, onTabChange }) => {

  const handleTabClick = (id) => {
    onTabChange && onTabChange(id);
  };

  return (
    <div className={classes.tabsContainer}>
      {tabs.map((tab, index) => (
        <div
          key={tab}
          className={`${classes.tab} ${activeTab === tab ? classes.activeTab : ""}`}
          onClick={() => handleTabClick(tab)}
        >
          {labels[index]}
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(Tabs);
